import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export const Description = ({description}) => {
  const { t } = useTranslation('common')

  return (
    <div className='oglasi-opis'>
      <div className='oglasi-info-heading'>
        <p>{t('Opis oglasa')}</p>
      </div>
      <p className='oglasi-opis-text'>{description}</p>
    </div>
  )
}

Description.propTypes = {
  description: PropTypes.string
}
